import { render } from "./OffersHomeShimmer.vue?vue&type=template&id=353edd1e"
import script from "./OffersHomeShimmer.vue?vue&type=script&lang=js"
export * from "./OffersHomeShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__